import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DateAdapter } from "@angular/material/core";
import moment from 'moment';
import { NuevoClienteComponent } from 'src/app/components/portal-inproeco/cliente/formularios/nuevo-cliente/nuevo-cliente.component';
import { MatDialog } from "@angular/material/dialog";

import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

//SERVICIOS
import { ClienteService } from 'src/app/services/cliente.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service'
import { DetalleService} from 'src/app/services/detalle.service'
import { detalleContenidoComponent } from '../detalle-cliente/detalle-cliente.component';
import { DocumentoService } from 'src/app/services/documento.service';
import Chart from 'chart.js';

@Component({
  selector: 'app-tabla-clientes',
  templateUrl: './tabla-clientes.component.html',
  styleUrls: ['./tabla-clientes.component.scss']
})

export class TablaClientesComponent implements OnInit {

  public clientes: any[] = []
  public loading: Boolean
  public tableColumns: String[]
  public title: String
  public dataSource?: any
  public filterValue?: string

  stackedBarChartCliente: any;
  stackedHorizontalBarOptions: any;
  allDoCentros:any =[]
  stackedBarChartTitleCliente: any;

  clientesColor:any = []


  @ViewChild('stackedCanvasTitleCliente') stackedCanvasTitleCliente: any;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;
  @ViewChildren('stackedCanvasCliente') stackedCanvasCliente: any;


  constructor( private apollo: Apollo, private clienteService: ClienteService, private confirmacionService: ConfirmacionService, private detalleService: DetalleService, date: DateAdapter<Date>, public dialog: MatDialog, private documentoService: DocumentoService) {
    this.loading = false;
    this.clientesColor = clienteService.getClientes()
    this.title = "Clientes"
    this.tableColumns = [/* 'id', */'nombreComercial' , 'cif', 'contactoResponsable.nombre', 'createdAt', 'indicadores', 'acciones']
    date.getFirstDayOfWeek = () => 1
    this.stackedHorizontalBarOptions = {
      hover: {
        animationDuration: 0
      },
      layout: {
        padding: 0
      },
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            scaleLabel: {
              display: false
            },
            stacked: true,
            ticks: {
              display: false,
              beginAtZero: false,
              fontFamily: "Helvetica, sans-serif",
              fontSize: 14
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            scaleLabel: {
              display: false
            },
            stacked: true,
            ticks: {
              display: false,
              fontFamily: "Helvetica, sans-serif",
              fontSize: 14
            }
          }
        ]
      },
      tooltips: {
        enabled: false
      }
    };
  }

  ngOnInit(): void {
    setTimeout(() => {
    this.getAllClientes()
    }, 300);
  }

  exportAsExcel() {
    
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Clientes");
    let header = ["Id", "Nombre Comercial", "CIF", "Contacto", "Fecha Alta"]
    let headerRow = worksheet.addRow(header);

    for (let cliente of this.clientes) {
      let temp = []
    
      // MAPEADO //
      temp.push(cliente["id"])
      temp.push(cliente["nombreComercial"])
      temp.push(cliente["cif"])
      temp.push(cliente["contactoResponsable"] ? cliente["contactoResponsable"]["nombre"]: '')
      temp.push(moment(cliente["createdAt"]).format('DD/MM/YYYY'))
        
      worksheet.addRow(temp)
     
    }

    let fname = "Tabla Clientes"

    workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fname + '-' + new Date().valueOf() + '.xlsx');
    });
  }


  getAllClientes(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientes(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.clientes = data.clientes
        this.setDataTableOptions()
        this.clientes.forEach((cliente:any)=>{
          this.getDocumentosByCliente(cliente.id)
        }) 
        this.getDocumentosAllClientes(data)
      })
  }

  setDataTableOptions(){
    if (this.clientesColor?.length > 0) {
    this.dataSource = new MatTableDataSource(this.clientesColor)
      
    }else{
    this.dataSource = new MatTableDataSource(this.clientes)

    }
    this.dataSource.paginator = this.paginator;   
    //TODO Filtro asc por NOMBRE funciona mal
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: any) => {
      return this.sortingData(item, property)
    };
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.filterPredicate(data, filter)
    }
  }

  applyFilter(e: any){
    this.filterValue = e.target.value
    this.dataSource.filter = this.filterValue?.trim().toLocaleLowerCase();
  }

  //TODO Filtrar y ordenar por agrupaciones porque puede haber varias opciones por fila
  filterPredicate(data: any, filter: string){
    const dateFormatted = moment(data.createdAt).format('DD/MM/YYYY')
    return data.id.toLocaleLowerCase().includes(filter) ||
            data.nombreComercial.toLocaleLowerCase().includes(filter) ||
            data.cif?.toLocaleLowerCase().includes(filter) ||
            data.contactoResponsable?.nombre.toLocaleLowerCase().includes(filter) ||
            dateFormatted.includes(filter);
  }

  sortingData(item: any, property: any){
    switch(property) {
      case 'nombreComercial': return item.nombreComercial;
      case 'contactoResponsable.nombre': return item.contactoResponsable?.nombre;
      //case 'agrupacion': return item.agrupaciones;
      default: return item[property];
    }
  }

  
  deleteClienteById(id: String){
    this.apollo.mutate({
      mutation: this.clienteService.deleteCliente(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', {data})
        location.reload()
      }, (error) => {
        console.log(error)
      })
  }

  handleClick(id: String){
    const options = {
      text: '¿Está seguro de eliminar este registro?',
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteClienteById(id)
      }
      });
  }

  openDialog() {
    this.dialog.open(NuevoClienteComponent);
  }

  openDetails(id: string){
    const options= {
      id: id,
    }
    this.detalleService.openTest(options, detalleContenidoComponent);
  }

  getDocumentosByCliente(canvas:any) {
    let docCentros:any =[]
    let step1:any = []
    let step2:any = []
    let allDocCentros:any = []
    let DocCentros:any = []
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosCentrosByClienteBar(),
      variables: {
        id: canvas
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        
        docCentros = data.cliente.centros
       
        DocCentros = [...DocCentros, docCentros]
       
        DocCentros.forEach((centro:any) => {
          step1 = [...step1, ...centro]
        });
      
        step1.forEach((element:any) => {
          step2.push(element.documentos)
        });
       
        step2.forEach((element:any) => {
          allDocCentros = [...allDocCentros, ...element]
        });
       
        
        const docClientesActivos = allDocCentros.filter((doc: any) => doc.tipo === 'activo' || doc.tipo === 'enEspera');
        
        let docRojo= docClientesActivos.filter((doc: any) => doc.estado == 'rojo');
        let docAmarillo = docClientesActivos.filter((doc: any) => doc.estado == 'amarillo');
        let docVerde = docClientesActivos.filter((doc: any) => doc.estado == 'verde')
        setTimeout(() => {
          this.stackedBarChartClientesMethod(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length, canvas)
        }, 300);

        let rojo = docRojo.length;
        let amarillo = docAmarillo.length;
        let verde = docVerde.length;

        /* for (let i = 0; i < allDocCentros.length; i++) {
          if (allDocCentros[i].tipo != 'pendiente') {
            
          
          switch (allDocCentros[i].estado) {
            case 'rojo':
              rojo++;
              break;
            case 'amarillo':
              amarillo++;
              break;
            case 'verde':
              verde++;
              break;

            default:
              break;
          }
        }
      } */
          const cliente = data.cliente

          if (rojo > 0 && cliente.estado != 'rojo') {
            const estado = 'rojo'
            this.updateClienteById(cliente.id, estado)
            return
          }
          if (amarillo > 0 && rojo == 0  && cliente.estado != 'amarillo') {
            const estado = 'amarillo'
            this.updateClienteById(cliente.id, estado)
            return
          }
          if (verde > 0 && amarillo == 0 && rojo == 0 && cliente.estado != 'verde') {
            const estado = 'verde'
            this.updateClienteById(cliente.id, estado)
            return
          }
      })
     
  }

  updateClienteById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })


  }

  stackedBarChartClientesMethod(fecha: any, caducado: any, proximo: any, canvas:any) {
    
    this.stackedBarChartCliente = new Chart(canvas, {
      type: 'horizontalBar',

      data: {
        labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
        datasets: [
          {
            data: [fecha],
            backgroundColor: '#00A131',
            label: 'Correcto'

          },
          {
            data: [proximo],
            backgroundColor: '#FF9E00',

          },
          {
            data: [caducado],
            backgroundColor: '#DC3737'

          }
        ]
      },
      options: this.stackedHorizontalBarOptions
    });
  
}
getDocumentosAllClientes(data:any){

  let docCentros:any = []
  let allDocCentros:any = []
  let allDocumentos:any = []
  console.log(data)
  data.clientes.forEach((cliente:any)=>{
    if (cliente.centros.length > 0) {
      docCentros.push(cliente.centros)
    }
    
  })


  docCentros.forEach((element:any) => {
    element.forEach((doc:any) => {
      allDocCentros.push(doc.documentos)
      
    });
  });

  allDocCentros.forEach((total:any) => {

      allDocumentos =[...allDocumentos, ...total]
    
    
  });


  const docClientesActivos = allDocumentos.filter((doc: any) => doc.tipo === 'activo' || doc.tipo === 'enEspera');
  
  let docRojo= docClientesActivos.filter((doc: any) => doc.estado == 'rojo');
  let docAmarillo = docClientesActivos.filter((doc: any) => doc.estado == 'amarillo');
  let docVerde = docClientesActivos.filter((doc: any) => doc.estado == 'verde')
  setTimeout(() => {
    this.stackedBarChartTitleClienteMethod(Object.keys(docVerde).length, Object.keys(docRojo).length, Object.keys(docAmarillo).length)
  }, 300);
  
 
}

stackedBarChartTitleClienteMethod(fecha: any, caducado: any, proximo: any) {

  this.stackedBarChartTitleCliente = new Chart(this.stackedCanvasTitleCliente.nativeElement, {
    type: 'horizontalBar',

    data: {
      labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
      datasets: [
        {
          data: [fecha],
          backgroundColor: '#00A131',
          label: 'Correcto'

        },
        {
          data: [proximo],
          backgroundColor: '#FF9E00',

        },
        {
          data: [caducado],
          backgroundColor: '#DC3737'

        }
      ]
    },
    options: this.stackedHorizontalBarOptions
  });

}

}
